export default __webpack_public_path__ + "static/media/keplrIcon.c8fae3f0.svg";